import React, { useEffect } from 'react';
import NProgress from 'nprogress';
import styles from './LoadingScreen.module.css';

function LoadingScreen() {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div className={styles.root}>
      Loading
    </div>
  );
}

export default LoadingScreen;
